//#region  import
import React, { Component } from 'react';
import propTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { customerApi } from '../../../services/apis';
import { returnMiladiDateByStandardFormat } from '../../../utils/utility/booking';
import { Input, ValidationMessage, RadioButton, Button } from '../../common';
import DatePicker from '../../../component/common/datePicker';
import { validateForm, validation } from '../../../utils/validation';
//#endregion
class CustomerManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        bussinessType: 'Individual',
        fullName: '',
        identificationNo: '',
        nationalNo: '',
        phone: '',
        email: '',
        address: '',
        birthDate: '',
        economyCode: '',
        postalCode: '',
        code: '',
        _id: '',
        fax: '',
      },
      customerLst: [],
      errors: {},
      loadingSubmit: false,
    };
  }
  //#region start scope : call api for insert customer
  doSubmit = async () => {
    const {
      bussinessType,
      fullName,
      identificationNo,
      nationalNo,
      phone,
      email,
      address,
      birthDate,
      economyCode,
      postalCode,
      code,
      fax,
    } = this.state.data;
    const { result, error } = this.validate();
    let customer = {
      _id: '0',
      code,
      fullName,
      identificationNo,
      nationalNo,
      birthDate: returnMiladiDateByStandardFormat(birthDate),
      address,
      phone,
      postalCode,
      email,
      economyCode,
      fax,
      profileId: parseInt(this.props.profileId),
      isBusiness: bussinessType === 'business',
      //at first customer should be disactive and accounting should active or disactive that
      isActive: false,
    };
    if (result) {
      try {
        this.setState({
          loadingSubmit: true,
        });
        const {
          status,
          payload: { data },
        } = await customerApi.addingCustomer({ data: customer });
        if (status === 200) {
          this.setState({
            loadingSubmit: false,
          });
          this.props.toastSatuation({
            alertMessage: 'profile.customerSuccessfullyRegistered',
            toastState: 'success',
          });
          //call select customer that insert and show it in drop down
          this.props.selectNewCustomer(data.insertedIds[0], customer);
        }
      } catch (error) {
        this.setState({
          loadingSubmit: false,
        });
        this.props.toastSatuation({
          alertMessage: 'user.tryagain',
          toastState: 'danger',
        });
      }
    }
  };
  //#end region

  //#region  start scope: function
  initialData = () => {
    // const initialData = {
    // 	bussinessType: 'Individual',
    // 	fullName: '',
    // 	identificationNo: '',
    // 	nationalNo: '',
    // 	phone: '',
    // 	email: '',
    // 	address: '',
    // 	birthDate: '',
    // 	economyCode: '',
    // 	postalCode: '',
    // 	code: '',
    // 	_id: '',
    // 	fax: '',
    // };
    this.setState({
      data: {
        bussinessType: 'Individual',
        fullName: '',
        identificationNo: '',
        nationalNo: '',
        phone: '',
        email: '',
        address: '',
        birthDate: '',
        economyCode: '',
        postalCode: '',
        code: '',
        _id: '',
        fax: '',
      },
    });
    return initialData;
  };
  //#endregion

  //#region  start scope: validation form

  //#endregion
  // VALIDATIONS
  validate = () => {
    const {
      bussinessType,
      fax,
      economyCode,
      phone,
      email,
      postalCode,
      identificationNo,
      birthDate,
      nationalNo,
      code,
      fullName,
    } = this.state.data;

    const { error, result } = validateForm({
      fullName: validation.string(fullName).required().errors,
      code: validation.number(code).required().errors,
      nationalNo: validation.number(nationalNo).required().errors,
      identificationNo: validation.number(identificationNo).required().errors,
      phone: validation.number(phone).required().errors,
      email: validation.email(email).required().errors,
      postalCode: validation.number(postalCode).required().errors,
      birthDate: validation.optional(birthDate),
      economyCode:
        bussinessType === 'Individual'
          ? validation.optional(economyCode).errors
          : validation.number(economyCode).required().errors,
      fax:
        bussinessType === 'Individual'
          ? validation.optional(fax).errors
          : validation.number(fax).required().errors,
    });
    return { error, result };
  };
  handleChange = ({ target: { name, value } }) => {
    this.setState(
      (state) => {
        state.data[name] = value;
        return state;
      },
      () => {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.validate().error[name],
          },
        });
      },
    );
  };
  //#region  start scope: handle events (handle submit )
  handleFormSubmit = (event) => {
    event.preventDefault();
    //validate data with new inputs
    const { errors, result } = this.validate();
    this.setState({ errors: errors || {} }, () => {
      if (result) this.doSubmit();
    });
  };
  //#endregion

  //#region start scope : rendering Gridview
  render() {
    const {
        data: {
          fullName,
          bussinessType,
          code,
          nationalNo,
          identificationNo,
          economyCode,
          fax,
          phone,
          email,
          postalCode,
          birthDate,
          address,
        },
        loadingSubmit,
      } = this.state,
      { formatMessage } = this.props.intl;
    const IS_INDIVIDUAL = bussinessType === 'Individual';

    return (
      <div className="w-100 ">
        <div className="col-12 px-0 d-flex flex-xs-row flex-column">
          {/* <div className='d-flex flex-row justify-content-start col-12'> */}
          <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 col-12 px-md-3 px-0 ">
            <div className="w-100 d-flex flex-row justify-content-start h-100">
              <img
                className="img-fluid default-border-radius-small w-100 h-100"
                alt=""
                src={require('../../../content/images/elements/add-personal.png')}
              />
            </div>
          </div>
          <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 pt-xs-0 pt-3 px-3 d-flex flex-column justify-content-start align-items-start">
            <span className="text-primary pt-md-5 pt-sm-4 pt-2 font-sm-xxlarge font-normal text-nowrap">
              <FormattedMessage id="profile.addCustomer" />
            </span>
            <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
              <p className="font-lg-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                <FormattedMessage id="profile.textCustomer" />
              </p>
            </div>
          </div>
          {/* </div> */}
        </div>
        <form
          id="customer-modal-form"
          name="customer-modal-form"
          onSubmit={this.handleFormSubmit}
          className="col-12 px-0"
        >
          <div className="d-flex flex-row p-0 w-100 pb-1 pt-4 pb-3 px-3">
            <RadioButton
              id="bussinessType-Individual"
              name="bussinessType"
              label="profile.Individual"
              checked={bussinessType === 'Individual'}
              onChange={() =>
                this.setState({
                  data: { ...this.state.data, bussinessType: 'Individual' },
                })
              }
              value="Individual"
            />
            <RadioButton
              id="bussinessType.business"
              name="bussinessType"
              label="profile.bussiness"
              checked={bussinessType === 'bussiness'}
              onChange={() =>
                this.setState({
                  data: { ...this.state.data, bussinessType: 'bussiness' },
                })
              }
              value="business"
            />
          </div>
          <div className="d-flex flex-row flex-wrap p-0 ">
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="fullName"
                type={'text'}
                label={formatMessage({
                  id: IS_INDIVIDUAL
                    ? 'profile.fullname'
                    : 'profile.companyname',
                })}
                value={fullName}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['fullName']} />
            </div>
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="code"
                type={'text'}
                label={formatMessage({
                  id: 'profile.accountingcode',
                })}
                value={code}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['code']} />
            </div>
          </div>

          <div className="d-flex flex-row flex-wrap p-0">
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="nationalNo"
                type={'text'}
                label={formatMessage({
                  id: IS_INDIVIDUAL
                    ? 'profile.nationalcode'
                    : 'profile.businessnationalid',
                })}
                value={nationalNo}
                onChange={this.handleChange}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['nationalNo']} />
            </div>
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="identificationNo"
                type={'text'}
                label={formatMessage({
                  id: IS_INDIVIDUAL
                    ? 'profile.identityno'
                    : 'profile.registercode',
                })}
                value={identificationNo}
                onChange={this.handleChange}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage
                errors={this.state.errors['identificationNo']}
              />
            </div>
          </div>

          {!IS_INDIVIDUAL && (
            <div className="d-flex flex-row flex-wrap p-0">
              <React.Fragment>
                <div className="col-sm-6 col-12 pb-4">
                  <Input
                    name="economyCode"
                    type={'text'}
                    label={formatMessage({
                      id: 'profile.businesseconomiccode',
                    })}
                    value={economyCode}
                    onChange={this.handleChange}
                    className={''}
                    themeMode="light"
                    outSideLabelClass="text-start"
                    outSideLabelPosition="top"
                    outSideLabel={true}
                    inputClassName={
                      'font-normal height-input-profile px-sm-3 px-3'
                    }
                  />
                  <ValidationMessage
                    errors={this.state.errors['economyCode']}
                  />
                </div>
                <div className="col-sm-6 col-12 pb-4">
                  <Input
                    name="fax"
                    type={'text'}
                    label={formatMessage({
                      id: 'profile.fax',
                    })}
                    value={fax}
                    onChange={this.handleChange}
                    className={''}
                    themeMode="light"
                    outSideLabelClass="text-start"
                    outSideLabelPosition="top"
                    outSideLabel={true}
                    inputClassName={
                      'font-normal height-input-profile px-sm-3 px-3'
                    }
                  />
                  <ValidationMessage errors={this.state.errors['fax']} />
                </div>
              </React.Fragment>
            </div>
          )}

          <div className="d-flex flex-row flex-wrap p-0">
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="phone"
                type={'text'}
                label={formatMessage({
                  id: 'profile.mobile',
                })}
                value={phone}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['phone']} />
            </div>
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="email"
                type={'email'}
                label={formatMessage({
                  id: 'profile.email',
                })}
                value={email}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['email']} />
            </div>
          </div>

          <div className="d-flex flex-row flex-wrap p-0 ">
            <div className="col-sm-6 col-12 pb-4">
              <Input
                name="postalCode"
                type={'text'}
                label={formatMessage({
                  id: 'profile.postalcode',
                })}
                value={postalCode}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['postalCode']} />
            </div>
            <div className="col-sm-6 col-12 pb-4">
              <DatePicker
                name={'birthDate'}
                value={birthDate}
                placeholder={formatMessage({
                  id: IS_INDIVIDUAL
                    ? 'profile.birthdate'
                    : 'profile.registerdate',
                })}
                className="pt-4"
                themeMode="light"
                withoutShadow={true}
                maxHeight="55px"
                heightSize="height-55px px-lg-0 px-3"
                inputClassName={'font-normal'}
                outSideLabelClassname={'dropDown-fontSize'}
                onChange={(date) => {
                  this.handleChange({
                    target: {
                      value: returnMiladiDateByStandardFormat(date),
                      // name: item.value,
                    },
                  });
                }}
                outSideLabel={true}
              />
              <ValidationMessage errors={this.state.errors['birthDate']} />
            </div>
          </div>

          <div className="d-flex flex-row flex-wrap p-0">
            <div className="col-sm-6 col-12">
              <Input
                name="address"
                type={'text'}
                label={formatMessage({
                  id: 'profile.address',
                })}
                value={address}
                onChange={this.handleChange}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
              />
              <ValidationMessage errors={this.state.errors['address']} />
            </div>
            <div className="col-sm-6 col-12 d-flex flex-column justify-content-center pt-sm-1 mt-sm-2 mt-3 pt-4 pb-sm-0 pb-3">
              <Button
                id="customer-modal-submit"
                name="customer-modal-submit"
                label={formatMessage({
                  id: 'profile.insertcustomer',
                })}
                className="btn-secondary mb-2 mb-sm-0"
                onClick={this.handleFormSubmit}
                disabled={!this.validate().result}
                loading={loadingSubmit}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
  //#endregion
}
CustomerManagement.propTypes = {
  profileId: propTypes.number,
  themeMode: propTypes.string,
};
CustomerManagement.defaultProps = {
  profileId: 0,
  themeMode: 'light',
};
export default injectIntl(CustomerManagement);
